<template>
  <div class="container">
    <div id="layout">
      <div id="north">
        <header-info cur="4"></header-info>
      </div>
      <div id="center">
        <div
          id="content"
          class="content"
        >

          <div
            class="login"
            id="state_login"
          >
            <div class="login_title">实验管理平台登录</div>
            <form
              class="login_form"
              id="loginForm"
              onsubmit="return false;"
            >
              <div class="login_item">
                <input
                  v-model="loginForm.username"
                  class="ipt"
                  id="user"
                  type="text"
                  autocomplete="off"
                  placeholder="用户名"
                  required=""
                  autofocus=""
                  @keydown.enter="login"
                >
              </div>
              <div
                class="login_item"
              >
                <input
                  v-model="loginForm.password"
                  class="ipt"
                  id="password"
                  type="password"
                  autocomplete="new-password"
                  placeholder="密码"
                  required=""
                  @keydown.enter="login"
                >
              </div>
              <div class="login_item item-verify hide">
                <input
                  v-model="loginForm.code"
                  class="ipt verify"
                  type="text"
                  autocomplete="off"
                  placeholder="验证码"
                  required=""
                  @keydown.enter="login"
                >
                <span
                  @click="getVerifyCode"
                  class="verify-code"
                  title="看不清，换一个"
                ><img :src="formatImage(verify.path)"></span>
              </div>
            </form>
            <div class="login_remenber_box clearfix">
<!--              <div class="login_resigter">-->
<!--                <router-link to="/register">注册</router-link>-->
<!--              </div>-->
<!--              <div class="login_remenber">-->
<!--                <router-link to="/www/find/password">忘记密码</router-link>-->
<!--              </div>-->
            </div>
            <div
              class="login_btn"
              id="loginBut"
              @click="login"
            >登录</div>
          </div>
        </div>
      </div>
      <div id="south">
        <footer-info></footer-info>
      </div>
    </div>

    <div
      id="dialog_overlay"
      style="visibility: hidden;"
    >
      <div id="dialog_bg"></div>
      <div
        id="dialog_panel"
        style="margin-left: -136px; margin-top: -52px;"
      >
        <div id="dialog_panel_bg"></div>
        <div id="dialog_title">提示</div>
        <div id="dialog_content"></div>
        <div id="dialog_control">
          <a
            href="javascript:void(0)"
            id="dialog_close"
            class="button"
            style="display:none;"
          >取消</a>
          <a
            href="javascript:void(0)"
            id="dialog_ok"
            class="button"
          >确认</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { uuid } from 'vue-uuid'
import HeaderInfo from '../../../components/HeaderInfo'
import FooterInfo from '../../../components/FooterInfo'

export default {
  name: 'Login',
  metaInfo: {
    meta: [
      { name: 'keywords', content: '虚拟仿真,实验,实验项目,本科,专科' }
    ]
  },
  components: {
    HeaderInfo,
    FooterInfo
  },
  data() {
    return {
      client_id: '',
      // 登录表单
      loginForm: {
        username: '',
        password: '',
        code: '',
        mobile_code: ''
      },
      verify: {
        path: '',
        // code: '',
        show: false
      },
      isMsgSend: false,
      interval: null,
      seconds: 0
    }
  },
  methods: {
    async login() {
      if (!this.loginForm.username) {
        this.$layer.msg('请输入用户名！')
        return
      }
      if (!this.loginForm.password) {
        this.$layer.msg('请输入密码！')
        return
      }
      if (this.verify.show && !this.loginForm.code) {
        this.$layer.msg('请输入验证码！')
        return
      }

      // 登录方法
      await this.$http.post('/secret_login/', {
        client_id: this.client_id,
        code: this.loginForm.code,
        username: this.utils.encryptDes(this.loginForm.username),
        password: this.utils.encryptDes(this.loginForm.password)
      }).then(async (data) => {
        if (!data.token) {
          await this.getVerifyCode()
          return this.$layer.msg('账号或密码输入错误！')
        }
        window.localStorage.clear()
        // 登录后添加token到vuex中
        // this.$cookies.set('token', data.token)
        this.$store.commit('setToken', data.token)

        this.$store.commit('setLoginTime', parseInt(Date.parse(new Date()) / 1000))

        await this.getUserInfo()
      }).catch(() => {
        this.getVerifyCode()
        this.$layer.msg('账号或密码输入错误！')
      })
    },
    async getUserInfo() {
      await this.$http.post('/login_user/', {}).then(async (data) => {
        // 如果不需要绑定手机 直接进入主页
        if (data.mobile_status === 0) {
          this.$store.commit('setUserInfo', data)
          await this.addLog(data.profile_id)
          this.$router.push('/')
        } else {
          // 如果需要手机 但是没有绑定 跳转到绑定手机页面
          // if (!data.mobile) {
          //   this.$layer.confirm('当前账号尚未绑定手机号，为了确保您的账号安全，请绑定手机号。', {
          //     title: '提示',
          //     showCancel: false,
          //     btn: ['绑定手机号', '取消'],
          //     icon: 3
          //   }, layerid => {
          //     this.$router.push('/bindphone?&profile_id=' + data.profile_id)
          //     this.$layer.close(layerid)
          //   }, layerid => {
          //     this.$layer.msg('执行取消')
          //     this.$layer.close(layerid)
          //   }
          //   )
          // } else {
          //   // 需要绑定手机 并且已经绑定了手机
          //   // 此时判断是否需要修改密码
          //   if (data.need_change_pass === 1) {
          //     this.$layer.confirm('请修改密码后再登录。', {
          //       title: '提示',
          //       showCancel: false,
          //       btn: ['修改密码', '取消'],
          //       icon: 3
          //     }, layerid => {
          //       this.$router.push('/www/find/password')
          //       this.$layer.close(layerid)
          //     }, layerid => {
          //       this.$layer.msg('执行取消')
          //       this.$layer.close(layerid)
          //     }
          //     )
          //   } else {
          //     this.$store.commit('setUserInfo', data)
          //     await this.addLog(data.profile_id)
          //     this.$router.push('/')
          //   }
          // }
          this.$store.commit('setUserInfo', data)
          await this.addLog(data.profile_id)
          this.$router.push('/')
        }
      }).catch(() => {
        alert('登陆失败！')
      })
    },
    async addLog(id) {
      await this.$http.post('/user_log/', {
        userprofile_id: id,
        category: 1,
        content: '登录首页'
      }).then(async (data) => {
      }).catch(() => {
        this.$layer.msg('添加日志失败！')
      })
    },

    async getVerifyCode() {
      await this.$http.get('/login_code/', {
        params: {
          client_id: this.client_id
        }
      }).then(async (data) => {
        this.verify.path = data.path
        this.verify.show = true
      }).catch((error) => {
        console.log(error)
      })
    },
    enterEvent(e) {
      if (e.keyCode === 13) {
        this.login()
      }
    },
    formatImage (path) {
      return this.$store.state.rootUrl + path
    },
    async sendMsg() {
      var mobile = /^1[3456789]\d{9}$/ // 手机号
      if (this.isMsgSend === true) {
        return
      } else if (!this.loginForm.username) {
        this.$layer.msg('手机号不能为空！')
        return
      } else if (!mobile.test(this.loginForm.username)) {
        this.$layer.msg('手机号格式有误！')
        return
      }

      await this.$http.get('/send_mobile/', {
        params: {
          client_id: this.client_id,
          mobile: this.loginForm.username,
          template: 'SMS_242700431'
        }
      }).then((data) => {
        this.$layer.msg('验证码已发送，有效期两分钟！')
        this.smsVerifyCode = data.data
        this.isMsgSend = true
        this.seconds = 120
        this.interval = setInterval(() => {
          if (this.seconds === 0) {
            clearInterval(this.interval)
            this.isMsgSend = false
          }
          this.seconds -= 1
        }, 1000)
      }).catch(() => {
        this.$parent.showMsg('发送验证码失败！')
      })
    }
  },
  mounted() {
    this.client_id = uuid.v1()
    this.getVerifyCode()

    if (this.$store.state.login_time) {
      const currentTime = parseInt(Date.parse(new Date()) / 1000)
      if (this.$store.state.login_time + (60 * 60 * 12) < currentTime) {
        this.$toast.error('您的登录已过期，请重新登录！', '', {
          position: 'topRight',
          messageColor: 'white',
          titleColor: 'white',
          iconColor: '#fff'
        })
        this.$store.commit('setToken', '')
        this.$store.commit('clearUserInfo')
        this.$store.commit('setLoginTime', 0)
      }
    }
    // window.localStorage.clear()
  }
}
</script>

<style scoped>
@import "../../../assets/css/dialog.css";
@import "../../../assets/css/login.css";

#south {
  position: relative;
  width: 100%;
  bottom: 0px;
}

.container {
  height: 100%;
}

#layout {
  height: 98%;
  visibility: visible;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-content: center;
}
#app #center {
  padding-bottom: 0;
  background: #f5f5f5;
}
#app > div {
  height: 100vh;
  min-height: 100vh;
}
.item-verify {
  display: flex;
}
.verify {
  flex: 1;
}
.login_type {
  text-align: center;
}
.login_type ul {
  margin-top: 20px;
}
.login_type ul li {
  display: inline;
  margin: 0 30px;
  font-size: 2rem;
  font-weight: bolder;
  color: #aaaaaa;
}
.login_type ul li.active {
  color: #0064ff;
}
.code {
  background: #73D6CA;
  display: block;
  width: 120px;
  height: 52px;
  color: #fff;
  line-height: 52px;
  text-align: center;
  cursor: pointer;
}
</style>
